export default {
  api: process.env.VUE_APP_API_URL,
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  apiTimeout: 50 * 1000,
  appSettings: {
    pageSize: 12,
    debounceTimeout: 500,
  },
  encryptionKey: process.env.VUE_APP_ENCRYPTION_KEY
};
